import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserProvajderView } from 'src/app/admin/orgjeddefgini/userprovajder/userprovajder-view';
import { BaseDataService } from 'yt-ng-framework';
import { TranslateService } from '@ngx-translate/core';
import { ModalService, ConfirmationDialogButtons } from 'yt-ng-framework';
@Injectable({
  providedIn: 'root'
})
export class SefAccessGuard implements CanActivate {

  constructor(
    private baseDataService: BaseDataService,
    protected modalService: ModalService,
    protected translateService: TranslateService,
    private router: Router) {}
    canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.baseDataService.Get(
      'UserProvajder',
      'GetByUserIDAndCompanyId',
      null,
      UserProvajderView,
      null
    ).pipe(
      map((data: UserProvajderView[]) => {
        const hasApyKey = Array.isArray(data) && data.some(x => !!x.ApyKey && x.ApyKey.trim() !== '');

        if (!hasApyKey) {
        this.translateService.get(["FW.ERRORS.EDOKUMENT.CHECKBEFORINSERTINGPURCHASE.APIKEY.EMPTY", "FW.TITLE.OBAVESTENJE"])
          .subscribe(translation => {
            this.router.navigate(['/']);
            this.modalService.ShowConfirmationDialog(translation["FW.TITLE.OBAVESTENJE"], translation["FW.ERRORS.EDOKUMENT.CHECKBEFORINSERTINGPURCHASE.APIKEY.EMPTY"], "warning", ConfirmationDialogButtons.Ok);
            return false;
           // this.notificationService.alert(translation['FW.ERRORS.EDOKUMENT.CHECKBEFORINSERTINGPURCHASE.APIKEY.EMPTY']);
          });        }
        // return hasApyKey;
        return true;
      }),
      catchError(error => {
        // this.router.navigate(['/unauthorized']);
        alert('Greška prilikom provere API key-a za SEF.');
        return of(false);
      })
    );
  }
}
